import React, { useContext, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Header from "./Header";
import { ProductContext } from "../context/AppContext";

const SpecialDocument = () => {
  const { registrationId } = useParams();
  const navigate = useNavigate();
  const authtoken = localStorage.getItem("token");
  const { userId } = useContext(ProductContext)

  console.log(registrationId, "registrationId 15 Special")

  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null);
  const [uploadedImageUrl, setUploadedImageUrl] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleUpdate = async (event) => {
    event.preventDefault();

    if (!selectedFile) {
      Swal.fire({
        icon: "warning",
        title: "No File Selected",
        text: "Please select a file to upload.",
      });
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("document", selectedFile);

    try {
      const response = await fetch(
        `https://api.mirai.healthcare/api/register/uploadDocument/${userId}`,
        {
          method: "PATCH",
          headers: {
            "x-auth": `${authtoken}`,
          },
          body: formData,
        }
      );

      const result = await response.json();
      console.log("Upload Success:", result);

      if (result?.imageUrl) {
        setUploadedImageUrl(result.imageUrl);
      }

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "File uploaded successfully!",
      });

      navigate("/registration");
    } catch (error) {
      console.error("Upload Failed:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "File upload failed!",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content content-two">
        <Header />
        <div className="row">
          <div className="col-md-12">
            <form onSubmit={handleUpdate}>
              <div className="card">
                <div className="card-header bg-light">
                  <h4 className="text-dark">Upload Document</h4>
                </div>
                <div className="card-body pb-1">
                  <div className="mb-3">
                    <label className="form-label">Upload Document</label>
                  </div>
                  <div className="d-flex align-items-center flex-wrap row-gap-3 mb-3">
                   
                    <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                      {preview ? (
                        <img
                          src={preview}
                          alt="Preview"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : uploadedImageUrl ? (
                        <img
                          src={uploadedImageUrl}
                          alt="Uploaded"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <i className="ti ti-photo-plus fs-16" />
                      )}
                    </div>

                    <div className="profile-upload">
                      <div className="profile-uploader d-flex align-items-center">
                        <div className="drag-upload-btn btn btn-primary mb-2 me-2">
                          Upload Document
                          <input
                            type="file"
                            className="form-control image-sign"
                            onChange={handleFileChange}
                          />
                        </div>
                      </div>
                      <p className="fs-12">
                        Upload image size 4MB, Format JPG, PNG, SVG
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-end">
                <button
                  className="btn btn-primary"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Uploading..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecialDocument;
